import run from "../../animate/run";

/**
 * Uncheck
 * @param {TriggerProps} trigger
 * @param {MainClassProps} main
 */
const uncheck = (trigger, main) => {
  run(main.events.get(`change:${trigger.get("name")}`), "leave", false);
};

export default uncheck;
